import { InjectionToken, InputSignal, OutputEmitterRef, Type } from '@angular/core';
import { NotificationDto } from '../models/notifications-grouped.model';

export interface NotificationItemBase {
  notification: InputSignal<NotificationDto>;
  markAsRead: OutputEmitterRef<number>;
  delete: OutputEmitterRef<number>;
}

export type NotificationItemRegistry = Map<string, Type<NotificationItemBase>>;

export const NOTIFICATION_ITEM_REGISTRY = new InjectionToken<NotificationItemRegistry>('NOTIFICATION_ITEM_REGISTRY');
